// Взлом (deus_vzlom, action) — цель: вражеский юнит. В Ф3: 1 урон.
// Если цель выжила (HP > 0 после урона) — Герой игрока +1 Влияния.

import { applyDamage } from '../../combat.js';
import { addInfluence } from './influence.js';
import { onUnitLeftField, dispatchUnitDied } from './hooks.js';
// Б.2.c: уведомление триггера «союзный персонаж получил урон» (Тёмный нетраннер).
import { notifyCharacterDamaged } from '../syntetics/temnyy-netranner.js';

export const CARD_ID = 'deus_vzlom';

// Цели — все живые вражеские юниты. (Стелс-юниты тоже доступны? Описание не уточняет —
// разрешим. Это action, не «обычная атака». Но для UX выбираем только видимых.)
export function getVzlomTargets(state, playerIdx) {
  const enemy = state.players[1 - playerIdx];
  return enemy.unitsOnField();
}

// Резолв в Ф3. targetCard — Card на момент резолва (мог уже умереть от другого Действия).
export function resolveVzlom(state, playerIdx, targetCard) {
  const p = state.players[playerIdx];
  const enemy = state.players[1 - playerIdx];
  if (!targetCard || !targetCard.isAlive() || targetCard.ownerId !== enemy.id) {
    state.log.add(`💻 ${p.name}: Взлом — цель уже недоступна, эффект не применён`);
    return { ok: false, reason: 'invalid_target' };
  }
  const before = { hp: targetCard.hp, armor: targetCard.armor };
  const r = applyDamage(targetCard, 1, { pierce: false });
  state.log.add(`💻 ${p.name}: Взлом → ${targetCard.name_ru} [${enemy.name}]: 1 урона (HP ${before.hp}→${targetCard.hp}, броня ${before.armor}→${targetCard.armor})`);
  // Б.2.c: триггер урона по союзнику (Тёмный нетраннер на стороне врага).
  const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
  if (taken > 0) notifyCharacterDamaged(state, enemy.id, targetCard, taken);
  if (targetCard.hp > 0) {
    addInfluence(state, playerIdx, 1, 'Взлом [цель выжила]');
  } else {
    enemy.removeFromField(targetCard);
    state.log.add(`✗ ${targetCard.name_ru} [${enemy.name}] погибает`);
    // А.4.4.2-fix1 (баг 3): полноценный death-event для deathrattle (Бот опергруппы и т.п.).
    dispatchUnitDied(state, { ownerIdx: enemy.id, card: targetCard, killer: null, killerIdx: playerIdx, killerWasCounter: false });
  }
  return { ok: true };
}
